import { render } from "./Contact.vue?vue&type=template&id=59f3c033"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=59f3c033&lang=css"
script.render = render

export default script